import { createSerializer } from 'nuqs';

import { paginationQueryParsers } from './product-search-nuqs-params';

export const paginationSerializer = createSerializer(paginationQueryParsers, {
   processUrlSearchParams: (search) => {
      search.sort();
      return search;
   }
});
